import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
// import { Link as LinkS } from "react-scroll";
import { HashLink as LinkH } from "react-router-hash-link";

export const LandingPage = styled.div`
  @keyframes fadeLeft {
    100% {
      width: 0px;
    }
  }
  @keyframes fadeRight {
    100% {
      height: 0px;
    }
  }
  @keyframes hide {
    50% {
      height: 300px;
      width: 300px;
    }
    99% {
      height: 200px;
      width: 200px;
    }
    100% {
      height: 0px;
    }
  }
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.color1};
  z-index: 5;
  animation: fadeLeft 2s;
  animation-delay: 1s;
  animation-fill-mode: forwards;
  img {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 200px;
    animation: hide 1s linear;
    animation-fill-mode: forwards;
  }
  @media screen and (max-width: 576px) {
    animation: fadeRight 2s;
    animation-delay: 1s;
    animation-fill-mode: forwards;
  }
`;
export const Nav = styled.div`
  font-family: Oswald;
  background-color: ${({ theme }) => theme.color1};
  position: fixed;
  transition: all 0.5s ease-out;
  width: ${({ menuopen }) => (menuopen ? "100%" : "80px")};
  z-index: 4;
  height: 100vh;

  @media screen and (max-width: 576px) {
    width: 100%;
    height: ${({ menuopen }) => (menuopen ? "100%" : "60px")};
    margin-top: ${({ scrollDir }) => (scrollDir ? "0px" : "-80px")};
  }
`;

export const Sidebar = styled.div`
  display: ${({ menuopen }) => (menuopen ? "none" : "flex")};
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media screen and (max-width: 576px) {
    flex-direction: row;
  }
`;
export const CenterBar = styled.div`
  display: ${({ menuopen }) => (menuopen ? "flex" : "none")};
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const MenuIcon = styled.div`
  margin-bottom: auto;
  font-size: 1.8rem;
  cursor: pointer;
  color: white;
  margin-top: 20px;
  z-index: 1;
  :hover {
    color: ${({ theme }) => theme.color2};
  }
  @media screen and (max-width: 576px) {
    margin: 0px auto 0px 20px;
  }
`;
export const CrossIcon = styled.div`
  position: absolute;
  color: white;
  cursor: pointer;
  font-size: 1.8rem;
  top: 20px;
  right: 20px;
  align-self: flex-end;
  :hover {
    color: ${({ theme }) => theme.color2};
  }
`;

export const NavLogoV = styled(LinkH)`
  color: ${({ theme }) => theme.color3};
  writing-mode: vertical-rl;
  text-orientation: upright;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
  margin-bottom: auto;
  text-transform: uppercase;
  @media screen and (max-width: 576px) {
    writing-mode: horizontal-tb;
    margin: 0px auto 0px 0px;
  }
`;
export const NavLogoH = styled(LinkH)`
  margin-top: 50px;
  color: ${({ theme }) => theme.color3};
  cursor: pointer;
  font-size: 2rem;
  font-weight: bold;
  text-decoration: none;
  margin-bottom: auto;
  text-transform: uppercase;
  :hover {
    color: ${({ theme }) => theme.color2};
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
  margin-bottom: auto;
`;

export const NavItem = styled.li`
  display: inline-block;
  height: 60px;
  margin-bottom: 20px;
  position: relative;
  font-weight: 900;
  :before {
    content: "";
    position: absolute;
    left: 0px;
    bottom: 2px;
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.color2};
    transform: scaleX(0);
    transition: transform 0.2s linear;
  }
  :hover:before {
    transform: scaleX(1);
  }
`;
export const NavLinks = styled(LinkH)`
  color: white;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 30px;
  height: 100%;
  cursor: pointer;
  transition: 0.5s border-bottom ease-in-out;
`;
export const NavBtn = styled.nav`
  display: flex;
  display: none;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavBtnLink = styled(LinkR)`
  border-radius: 50px;
  background: ${({ theme }) => theme.color2};
  white-space: nowrap;
  padding: 10px 22px;
  color: white;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ theme }) => theme.color2};
  }
`;
